(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/star-confetti.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/star-confetti.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const normalizedFps = 144; 
const starsPerCannon = 13;
const numberOfBursts = 6;
const cannonInterval = 320;
const minStarSize = 17;
const starSizeVariation = 32;
const imgPath = "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticketgames/ticket-utility/stars.png");
let ctx;
let canvas;
let isRunning = false;
let particles = [];
let ticks = 0;
let uniqueId = 0;
let avgFps = 0;
let frames = [];
let optimized = false;
let lastFrameTime = performance.now();
let delta = 0;
let image;
let animationFrame;
let cannonTimer;
let animationRun = 0;
const framesBig = [{
  x: 1,
  y: 1,
  w: 446,
  h: 414
}, {
  x: 449,
  y: 1,
  w: 367,
  h: 357
}, {
  x: 818,
  y: 1,
  w: 373,
  h: 325
}];
const framesSmall = [{
  x: 1193,
  y: 1,
  w: 53,
  h: 53
}, {
  x: 1248,
  y: 1,
  w: 73,
  h: 74
}, {
  x: 1323,
  y: 1,
  w: 50,
  h: 51
}, {
  x: 1375,
  y: 1,
  w: 50,
  h: 51
}, {
  x: 1427,
  y: 1,
  w: 94,
  h: 96
}, {
  x: 1523,
  y: 1,
  w: 77,
  h: 81
}, {
  x: 1602,
  y: 1,
  w: 69,
  h: 73
}, {
  x: 1673,
  y: 1,
  w: 94,
  h: 95
}];
async function init() {
  if (canvas) {
    cleanup();
  }
  const currentRun = ++animationRun;
  canvas = document.createElement('canvas');
  canvas.style.position = 'fixed';
  canvas.style.top = 0;
  canvas.style.left = 0;
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = 1000;
  ctx = canvas.getContext('2d');
  document.body.appendChild(canvas);
  window.addEventListener('resize', setCanvasSize);
  setCanvasSize();
  isRunning = true;
  await setup();
  if (currentRun !== animationRun) {
    return;
  }
  spawnCannon();
  animationFrame = requestAnimationFrame(tick);
}
function cleanup() {
  var _canvas;
  animationRun++;
  isRunning = false;
  clearInterval(cannonTimer);
  cancelAnimationFrame(animationFrame);
  window.removeEventListener('resize', setCanvasSize);
  frames = [];
  particles = [];
  (_canvas = canvas) === null || _canvas === void 0 || _canvas.remove();
  canvas = null;
  ctx = null;
  cannonTimer = null;
  animationFrame = null;
}
function setCanvasSize() {
  const canvas = ctx.canvas;
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  ctx.width = canvas.width;
  ctx.height = canvas.height;
}
class Particle {
  constructor(_ref) {
    let x = _ref.x,
      y = _ref.y,
      w = _ref.w,
      h = _ref.h,
      velocity = _ref.velocity,
      id = _ref.id,
      frames = _ref.frames,
      rotationVelocity = _ref.rotationVelocity;
    this.id = id;
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    this.alpha = 1;
    this.frames = frames;
    this.imgIndex = Math.floor(Math.random() * this.frames.length);
    this.velocity = velocity;
    this.rotation = Math.random() * Math.PI * 2;
    this.rotationVelocity = rotationVelocity;
    this.gravity = Math.random() * 0.016 + 0.035;
    this.drag = Math.random() * 0.006 + 0.988;
    this.sway = Math.random() * 0.11 + 0.05;
    this.swayPosition = Math.random() * Math.PI * 2;
    this.swaySpeed = Math.random() * 0.018 + 0.012;
    this.flip = Math.random() * Math.PI * 2;
    this.flipSpeed = Math.random() * 0.035 + 0.015;
  }
  draw() {
    const _this$frames$this$img = this.frames[this.imgIndex],
      x = _this$frames$this$img.x,
      y = _this$frames$this$img.y,
      w = _this$frames$this$img.w,
      h = _this$frames$this$img.h;
    ctx.save();
    if (!optimized) {
      ctx.shadowColor = 'rgba(0, 0, 0, 0.25)';
      ctx.shadowBlur = 4;
      ctx.shadowOffsetX = 2;
      ctx.shadowOffsetY = 3;
    } else {
      ctx.shadowColor = 'rgba(255, 255, 255, 0)';
      ctx.shadowBlur = 0;
    }
    ctx.globalAlpha = this.alpha;
    ctx.translate(this.x + this.w / 2, this.y + this.h / 2);
    ctx.rotate(this.rotation);
    ctx.scale(Math.cos(this.flip), 1);
    ctx.drawImage(image, x, y, w, h, -this.w / 2, -this.h / 2, this.w, this.h);
    ctx.restore();
  }
  update() {
    if (this.checkBounds()) {
      particles = particles.filter(p => p.id !== this.id);
      if (particles.length === 0) {
        isRunning = false;
      }
      return;
    }

    if (ticks % 15 === 0) {
      this.imgIndex = (this.imgIndex + 1) % this.frames.length;
    }
    const frameDelta = delta * normalizedFps;
    const _this$velocity = _slicedToArray(this.velocity, 2),
      xVelocity = _this$velocity[0],
      yVelocity = _this$velocity[1];
    this.swayPosition += this.swaySpeed * frameDelta;
    this.x += (xVelocity + Math.sin(this.swayPosition) * this.sway) * frameDelta;
    this.y += yVelocity * frameDelta;
    this.rotation += this.rotationVelocity * frameDelta;
    this.flip += this.flipSpeed * frameDelta;
    this.velocity[1] += this.gravity * frameDelta;
    this.velocity[0] *= this.drag ** frameDelta;
    const fadeStart = ctx.height * 0.75;
    if (this.velocity[1] > 0 && this.y > fadeStart) {
      this.alpha = Math.max(0, 1 - (this.y - fadeStart) / (ctx.height - fadeStart));
    } else {
      this.alpha = 1;
    }
  }
  checkBounds() {
    const leftBound = -ctx.width / 2;
    const rightBound = ctx.width + ctx.width / 2;
    const topBound = -ctx.height * 2;
    return this.alpha <= 0 || this.x < leftBound || this.x > rightBound || this.y < topBound;
  }
}
function spawnCannon() {
  const widthFactor = Math.max(ctx.width / 1000, 0.65);
  const heightFactor = ctx.height / 1000;
  let burstIndex = 0;
  const shootFromCorner = fromLeft => {
    const x = fromLeft ? 0 : ctx.width;
    const y = ctx.height;
    for (let i = 0; i < starsPerCannon; i++) {
      const w = Math.random() * starSizeVariation + minStarSize;
      const h = w;
      const horizontalVelocity = (Math.random() * 3.7 + 2.8) * widthFactor;
      const velocity = [fromLeft ? horizontalVelocity : -horizontalVelocity, -(Math.random() * 3.5 + 5.3) * heightFactor];
      const id = uniqueId++;
      const isLarge = Math.random() > 0.5;
      const frames = isLarge ? framesBig : framesSmall;
      const rotationVelocity = Math.random() * 0.024 - 0.012;
      const particle = new Particle({
        x: x - w / 2 + (Math.random() * 16 - 8),
        y: y - h / 2 + (Math.random() * 24 - 12),
        w,
        h,
        velocity,
        id,
        frames,
        rotationVelocity
      });
      particles.push(particle);
    }
  };
  const shootBurst = () => {
    shootFromCorner(true);
    shootFromCorner(false);
    burstIndex++;
  };
  shootBurst();
  cannonTimer = setInterval(() => {
    shootBurst();
    if (burstIndex === numberOfBursts) {
      clearInterval(cannonTimer);
      cannonTimer = null;
    }
  }, cannonInterval);
}
async function setup() {
  lastFrameTime = performance.now();
  image = new Image();
  image.src = imgPath;
  await new Promise((resolve, reject) => {
    image.onload = resolve;
    image.onerror = reject;
  });
  optimized = false;
}
function tick() {
  if (!isRunning) {
    cleanup();
    return;
  }
  ticks++;
  if (!optimized) {
    frames.push(performance.now());
    if (frames.length > 100) {
      frames.shift();
    }
    avgFps = 1000 / ((frames[frames.length - 1] - frames[0]) / 100);
    if (avgFps < 45 && frames.length >= 100) {
      optimized = true;
    }
  }
  delta = Math.min((performance.now() - lastFrameTime) / 1000, 1 / 30);
  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  particles.forEach(particle => {
    particle.update();
    particle.draw();
  });
  lastFrameTime = performance.now();
  animationFrame = requestAnimationFrame(tick);
}
setGlobal('svs.ticketUtility.utils.starConfetti', init);

 })(window);